<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Milford</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-heada" id="Ack">A<span class="small">CKNOWLEDGMENTS</span></p>
<p class="para1">I wouldn’t have been able to put this book together without the help of these fine people and organizations. Thanks to the members of the Milford and Devon Facebook pages, who provided so much inspiration; Katherine Krauss Murphy, who suggested writing this book, provided information and pictures of Woodmont, and also helped with the editing; Daniel E. and Roma C. Moger (DRM) photo collection; the New Haven Museum (NHM); the Milford Historical Society (MHS); Lasse’s Restaurant (LR); Milford Yacht Club (MYC); Connecticut Post Mall (CPM); Nancy Hermann (NH); Eleanor R. Benefico (ERB); Margaret G. Giles (MGG); Moe Knox (MK); James Stewart (JS); Richard Smith (RS); Thomas F. Mayer (TFM); Connie Pascarella (CP); James Simone (JS); David Gregory (DG); Stephanie Gloria Sullo (SGS); James Chedister (JC); Rev. Karl Duetzmann (RKD); Rev. Kenneth Fellenbaum (RKF); and Dick Platt (DP) and Tim Chaucer (TC), not only for their contributions, but also for their tireless efforts in going above and beyond to save Milford’s historic landmarks. All of the Now photographs that appear are from the author’s collection.</p>
<p class="para">Unless otherwise stated, all images are from the author’s collection.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?d49e8d2e